import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { BookProvider } from './contexts/BookContext';
import { CommentProvider } from './contexts/CommentContext';
import Header from './components/common/Header/Header';
import Footer from './components/common/Footer/Footer';
import HomePage from './components/pages/HomePage';
import LoginPage from './components/pages/LoginPage';
import RegisterPage from './components/pages/RegisterPage';
import ResetPasswordPage from './components/pages/ResetPasswordPage';
import DashboardPage from './components/pages/DashboardPage';
import EmailVerificationPage from './components/pages/EmailVerificationPage';
import EmailVerifiedPage from './components/pages/EmailVerifiedPage';
import ProtectedRoute from './components/common/ProtectedRoute/ProtectedRoute';
import './styles/globals.css';

function App() {
  return (
    <AuthProvider>
      <BookProvider>
        <CommentProvider>
          <Router>
            <div className="app">
              <Header />
              <main className="main-content">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/register" element={<RegisterPage />} />
                  <Route path="/reset-password" element={<ResetPasswordPage />} />
                  <Route path="/email-verification" element={<EmailVerificationPage />} />
                  <Route path="/verify-email" element={<EmailVerifiedPage />} />
                  <Route 
                    path="/dashboard" 
                    element={
                      <ProtectedRoute>
                        <DashboardPage />
                      </ProtectedRoute>
                    } 
                  />
                </Routes>
              </main>
              <Footer />
            </div>
          </Router>
        </CommentProvider>
      </BookProvider>
    </AuthProvider>
  );
}

export default App;
